module.exports = __webpack_public_path__ + "static/img/company_logo_icon_white.8b07d3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company_logo_icon_white.png
// module id = vGk7
// module chunks = 1